var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-switch", {
            attrs: { label: _vm.$ct("price-category-add-discount") },
            model: {
              value: _vm.value.Discount,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Discount", $$v)
              },
              expression: "value.Discount",
            },
          }),
          _c(
            "w-transition-slide-height",
            [
              _vm.value.Discount
                ? _c(
                    "w-row",
                    { staticClass: "border", attrs: { "no-margin": "" } },
                    [
                      _c(
                        "w-col",
                        {
                          style: { display: "flex", flexDirection: "row" },
                          attrs: { xs: "12" },
                        },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.value.Debet
                                    ? _vm.$ct("labels.debet-amount")
                                    : _vm.$ct("labels.credit-amount"),
                                  expression:
                                    "value.Debet ? $ct('labels.debet-amount') : $ct('labels.credit-amount')",
                                },
                              ],
                              staticClass: "dc-switch",
                              style: {
                                height: "100%",
                                marginRight: "8px",
                                marginBottom: "2px",
                                fontSize: "18px",
                                width: "35px",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.value.Debet = !_vm.value.Debet
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.value.Debet ? "+" : "-") + " "
                              ),
                            ]
                          ),
                          _c("w-input-number", {
                            style: { flexGrow: 1 },
                            attrs: {
                              fancy: "",
                              label: "kortingspercentage",
                              icon: "percent",
                            },
                            model: {
                              value: _vm.value.DiscountPercentage,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "DiscountPercentage", $$v)
                              },
                              expression: "value.DiscountPercentage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }